import { ObjType } from "./BaseEntity";

/** トライアル */
export const CONTRACT_TRIAL: ObjType = {
  true: "トライアル",
  false: "-",
}